var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Checkbox, FormControlLabel, RadioGroup, Radio, Autocomplete, Chip, TextField as MuiTextField, Button, Switch, Typography, } from "@mui/material";
import { CellType, } from "../../../types/forms";
import { isValueEmpty } from "../../../utils/forms-functions";
import { applyExpressionFormat, getExpressionValueAsStr, } from "../components/fields/constants/expression";
export var getDefaultCellValue = function (cellType) {
    switch (cellType) {
        case CellType.CHECKBOX:
        case CellType.TAGBOX:
            return [];
        case CellType.BOOLEAN:
            return false;
        case CellType.RATING:
            return null;
        case CellType.TEXT:
        case CellType.COMMENT:
        case CellType.RADIOGROUP:
            return "";
        default:
            return "";
    }
};
var isCellDisabled = function (props) { var _a; return (_a = props.cellDisabled) !== null && _a !== void 0 ? _a : props.element.readOnly === true; };
var renderCheckboxCell = function (props) {
    var row = props.row, column = props.column, cellValue = props.cellValue, choiceValues = props.choiceValues, onCellChange = props.onCellChange;
    var disabled = isCellDisabled(props);
    var selectedValues = (Array.isArray(cellValue) ? cellValue : []).map(function (value) { return value.toString(); });
    return (_jsx(Box, __assign({ sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 0.5,
            p: 1,
        } }, { children: choiceValues.map(function (choice) {
            var isChecked = selectedValues.includes(choice.value);
            return (_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: isChecked, onChange: function (e) {
                        var newValues = e.target.checked
                            ? __spreadArray(__spreadArray([], selectedValues, true), [choice.value], false) : selectedValues.filter(function (v) { return v !== choice.value; });
                        onCellChange(row, column, newValues);
                    }, disabled: disabled, size: "small" }), label: choice.text, sx: {
                    m: 0,
                    width: "auto",
                    "& .MuiFormControlLabel-label": {
                        width: "auto",
                    },
                } }, choice.value));
        }) })));
};
var renderRadioGroupCell = function (props) {
    var row = props.row, column = props.column, cellValue = props.cellValue, choiceValues = props.choiceValues, onCellChange = props.onCellChange;
    var disabled = isCellDisabled(props);
    return (_jsx(RadioGroup, __assign({ value: cellValue, onChange: function (e) {
            var newValue = e.target.value;
            onCellChange(row, column, newValue);
        }, sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: 0.5,
            p: 1,
        } }, { children: choiceValues.map(function (choice) { return (_jsx(FormControlLabel, { value: choice.value, control: _jsx(Radio, { disabled: disabled, size: "small" }), label: choice.text, sx: {
                m: 0,
                flex: "0 1 auto",
            } }, choice.value)); }) })));
};
var renderTagboxCell = function (props) {
    var row = props.row, column = props.column, cellValue = props.cellValue, element = props.element, choiceValues = props.choiceValues, onCellChange = props.onCellChange;
    var disabled = isCellDisabled(props);
    var selectedValues = (Array.isArray(cellValue) ? cellValue : []).map(function (value) { return value.toString(); });
    var selectedChoices = choiceValues.filter(function (choice) {
        return selectedValues.includes(choice.value);
    });
    return (_jsx(Autocomplete, { multiple: true, disableCloseOnSelect: true, size: "small", options: choiceValues, value: selectedChoices, onChange: function (_, newValue) {
            var newValues = newValue.map(function (choice) { return choice.value; });
            onCellChange(row, column, newValues);
        }, disabled: disabled, getOptionLabel: function (option) { return option.text; }, isOptionEqualToValue: function (option, value) { return option.value === value.value; }, renderInput: function (params) { return (_jsx(MuiTextField, __assign({}, params, { placeholder: element.placeholder || "Selecione" }))); }, renderTags: function (value, getTagProps) {
            return value.map(function (choice, index) { return (_createElement(Chip, __assign({ label: choice.text }, getTagProps({ index: index }), { key: index, size: "small" }))); });
        }, sx: { minWidth: 150 } }));
};
var renderTextCell = function (props) {
    var row = props.row, column = props.column, cellValue = props.cellValue, onCellChange = props.onCellChange;
    var disabled = isCellDisabled(props);
    return (_jsx(MuiTextField, { value: cellValue || "", onChange: function (e) { return onCellChange(row, column, e.target.value); }, disabled: disabled, size: "small", fullWidth: true, sx: { minWidth: 150 } }));
};
var renderCommentCell = function (props) {
    var row = props.row, column = props.column, cellValue = props.cellValue, onCellChange = props.onCellChange, autoGrowComment = props.autoGrowComment;
    var disabled = isCellDisabled(props);
    var FIXED_ROWS = 2;
    var rowsProps = autoGrowComment
        ? { minRows: FIXED_ROWS }
        : { rows: FIXED_ROWS };
    return (_jsx(MuiTextField, __assign({ value: cellValue || "", onChange: function (e) { return onCellChange(row, column, e.target.value); }, disabled: disabled, size: "small", fullWidth: true, multiline: true }, rowsProps, { sx: {
            minWidth: 150,
            "& .MuiInputBase-inputMultiline": {
                resize: autoGrowComment ? "none" : "vertical",
            },
        } })));
};
var renderBooleanCell = function (props) {
    var row = props.row, column = props.column, cellValue = props.cellValue, element = props.element, onCellChange = props.onCellChange;
    var disabled = isCellDisabled(props);
    var elementLabelTrue = element.labelTrue || "Sim";
    var elementLabelFalse = element.labelFalse || "Não";
    return (_jsx(FormControlLabel, { control: _jsx(Switch, { checked: Boolean(cellValue), onChange: function (e) { return onCellChange(row, column, e.target.checked); }, disabled: disabled, size: "small" }), label: cellValue ? elementLabelTrue : elementLabelFalse, sx: { m: 0 } }));
};
var renderRatingCell = function (props) {
    var row = props.row, column = props.column, cellValue = props.cellValue, _a = props.rateCount, rateCount = _a === void 0 ? 5 : _a, onCellChange = props.onCellChange;
    var disabled = isCellDisabled(props);
    return (_jsx(Box, __assign({ sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
            flexWrap: "wrap",
        } }, { children: Array.from({ length: rateCount }, function (_, i) {
            var value = i + 1;
            var isSelected = cellValue === value;
            return (_jsx(Button, __assign({ variant: isSelected ? "contained" : "outlined", onClick: function () { return onCellChange(row, column, value); }, disabled: disabled, sx: {
                    minWidth: 40,
                    height: 40,
                    fontSize: "0.9rem",
                    fontWeight: isSelected ? 600 : 400,
                } }, { children: value }), value));
        }) })));
};
var renderDropdownCell = function (props) {
    var _a;
    var row = props.row, column = props.column, cellValue = props.cellValue, element = props.element, choiceValues = props.choiceValues, onCellChange = props.onCellChange, error = props.error;
    var disabled = isCellDisabled(props);
    var fieldValue = String(cellValue !== null && cellValue !== void 0 ? cellValue : "");
    var selectedOption = fieldValue
        ? (_a = choiceValues.find(function (c) { return c.value === fieldValue; })) !== null && _a !== void 0 ? _a : null
        : null;
    return (_jsx(Autocomplete, { size: "small", options: choiceValues, value: selectedOption, disabled: disabled, getOptionLabel: function (option) { return option.text; }, isOptionEqualToValue: function (option, value) { return option.value === value.value; }, onChange: function (_, newOption) {
            var _a;
            var newValue = (_a = newOption === null || newOption === void 0 ? void 0 : newOption.value) !== null && _a !== void 0 ? _a : "";
            onCellChange(row, column, newValue);
        }, renderInput: function (params) { return (_jsx(MuiTextField, __assign({}, params, { placeholder: element.placeholder || "Selecione", error: !!error }))); }, sx: { minWidth: 120 } }));
};
var renderExpressionCell = function (props) {
    var row = props.row, column = props.column, cellValue = props.cellValue, columnDefinition = props.columnDefinition;
    var displayValue = isValueEmpty(cellValue) || !columnDefinition
        ? ""
        : applyExpressionFormat(getExpressionValueAsStr(cellValue, columnDefinition), columnDefinition.format);
    return (_jsx(Typography, __assign({ variant: "body2", "data-testid": "expression-cell-".concat(column, "-").concat(row) }, { children: displayValue })));
};
export var renderMatrixCell = function (props) {
    var cellType = props.cellType || props.element.cellType || CellType.DEFAULT;
    switch (cellType) {
        case CellType.CHECKBOX:
            return renderCheckboxCell(props);
        case CellType.RADIOGROUP:
            return renderRadioGroupCell(props);
        case CellType.TAGBOX:
            return renderTagboxCell(props);
        case CellType.TEXT:
            return renderTextCell(props);
        case CellType.COMMENT:
            return renderCommentCell(props);
        case CellType.BOOLEAN:
            return renderBooleanCell(props);
        case CellType.RATING:
            return renderRatingCell(props);
        case CellType.EXPRESSION:
            return renderExpressionCell(props);
        default:
            return renderDropdownCell(props);
    }
};
